import { useGame } from "./GameContext";

import "./header.css";

export default function Header({ backgroundNone0 = false }) {
  const { backgroundNone, clearedStages, MISSION_TOTAL } = useGame();

  /* 배경 우선순위
     1. 컴포넌트에서 받은 backgroundNone0 === true
     2. Context backgroundNone === true
  */
  const backgroundNoneVal =
    backgroundNone0 === true ? true : backgroundNone === true;

  return (
    <>
      <div
        id="box_hd"
        style={backgroundNoneVal ? { background: "none" } : undefined}
      >
        <div className="box_hd_lt">
          <span className="hd-game_title">키자니아 갤럭시 AI 비밀본부</span>
        </div>

        <div className="box_hd_rt">
          <div className="hd-storage">
            <span className="hd-storage_icon"></span>
            <span className="hd-storage_title">
              {clearedStages.size}/{MISSION_TOTAL}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
